import { IFile, IRightToRepresent } from 'wisestep-api';

export interface IExcelRecords extends IFile, IRightToRepresent {
  rowsValues: string[];
}

export interface IDialogState {
  uploadCvDialog: boolean;
  deleteCVDialog: boolean;
  uploadRtrDialog: boolean;
  deleteRtrDialog: boolean;
}

export const initialDialogState: IDialogState = {
  uploadCvDialog: false,
  deleteCVDialog: false,
  uploadRtrDialog: false,
  deleteRtrDialog: false,
};
